module.exports = __webpack_public_path__ + "img/T6-D-rc_16.64d3cb95.png";